// What crypto-js wrote starts with `Salted__` in base64.
const LEGACY_CIPHER_PREFIX = 'U2FsdGVkX1';
export const isLegacyCipher = (value) => typeof value === 'string' && value.startsWith(LEGACY_CIPHER_PREFIX);
